import { FadeIn, Footer, Header } from "../components"
import type { NextPage } from "next"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"
import Script from "next/script"

const Careers: NextPage = () => {
  const router = useRouter()
  const canonicalUrl = (
    `https://www.coverdash.com` + (router.asPath === "/" ? "" : router.asPath)
  ).split("?")[0]

  return (
    <>
      <NextSeo
        title="Careers - Join Our Team"
        canonical={canonicalUrl}
        openGraph={{
          url: canonicalUrl,
          title: "Careers - Join Our Team",
          description:
            "Join Coverdash and help make insurance accessible to businesses of all shapes and sizes.",
        }}
      />
      <Header />
      <div className="min-h-screen bg-[#f7f8fa] pt-16 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <FadeIn>
            <div className="text-center mb-12">
              <h1 className="text-4xl tracking-tight font-extrabold sm:text-5xl md:text-6xl text-alt">
                Join Our <span className="text-primary">Team</span>
              </h1>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                Help us make insurance accessible to businesses of all shapes
                and sizes. We're building the future of embedded insurance.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="max-w-6xl mx-auto">
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="p-6 sm:p-8 lg:p-12">
                  <div id="ashby_embed"></div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
      <Footer />

      <Script
        src="https://jobs.ashbyhq.com/coverdash/embed?version=2"
        strategy="afterInteractive"
      />
    </>
  )
}

export default Careers
